import {Component} from '@angular/core';

@Component({templateUrl: './bigger-screen-required.component.html', selector: 'app-bigger-screen-required'})
export class BiggerScreenRequiredComponent {
}
